import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';

export const useWordCountTracker = (editorRef, editorInitialized) => {
  const [wordCount, setWordCount] = useState(0);

  const getWordCount = useCallback((ref) => {
    if (ref.current) {
      return ref.current.plugins.wordcount.getCount();
    }
    return 0;
  }, []);

  const debouncedSetWordCount = useCallback(
    debounce((count) => {
      setWordCount(count);
    }, 300),
    []
  );

  useEffect(() => {
    if (!editorInitialized) return;
    setWordCount(getWordCount(editorRef));
  }, [editorInitialized]);

  return {
    wordCount,
    setWordCount,
    getWordCount,
    debouncedSetWordCount,
  };
};
